import { observer } from 'mobx-react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { useStores } from '../../hooks/useStores';
import { Flex } from '../Flex';
import { CSVIcon } from '../CSVIcon';

const Container = styled.div`
  padding: ${({ theme }) => theme.space[3]};
  margin-bottom: 10px;
`;

const ProgressBarContainer = styled(Container)`
  width: 200px;
  height: 10px;
`;

const ProgressBar = withStyles({
  root: {
    width: '100%',
    height: '100%',
  },
})(LinearProgress);

const ProductImportProgressModal = () => {
  const { allProductsPage } = useStores();

  return (
    allProductsPage.isImportProgressModalOpen && (
      <Dialog
        open={allProductsPage.isImportProgressModalOpen}
        onClose={allProductsPage.closeProductImportProgressModal}
        maxWidth="sm"
      >
        <MuiDialogContent>
          <Flex
            alignItems="center"
            justifyContent="center"
            alignContent="space-between"
            flexDirection="column"
          >
            <Container>
              <CSVIcon />
            </Container>
            <Container>
              <Typography variant="body2">
                {allProductsPage.importJob.fileName}
              </Typography>
            </Container>
            <ProgressBarContainer>
              {!allProductsPage.isImporterJobComplete && <ProgressBar />}
              {allProductsPage.isImporterJobComplete && (
                <ProgressBar variant="determinate" value={100} />
              )}
            </ProgressBarContainer>
            <Container>
              <Typography variant="body1">Importing your products</Typography>
            </Container>
          </Flex>
        </MuiDialogContent>
      </Dialog>
    )
  );
};

export default observer(ProductImportProgressModal);
